import { selectRoles } from '@modules/admin/Admin.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import SelectField from './SelectField'
import './MultiSelect.scss'

class SelectRoleField extends Component {
  static defaultProps = {
    roles: [],
  }

  render() {
    const { roles, placeholder, multi, t } = this.props
    return (
      <SelectField {...this.props} placeholder={placeholder || `${multi ? t('Roles') : t('Rol')}`} options={roles} />
    )
  }
}

const mapStateToProps = (state) => ({
  roles: selectRoles(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectRoleField)
